import { render, staticRenderFns } from "./ai-models.vue?vue&type=template&id=47e33f81&scoped=true"
import script from "./ai-models.vue?vue&type=script&lang=js"
export * from "./ai-models.vue?vue&type=script&lang=js"
import style0 from "./ai-models.vue?vue&type=style&index=0&id=47e33f81&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e33f81",
  null
  
)

export default component.exports